import { startOfWeek } from "date-fns";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";
import { getDayNumber } from "../../scheduler/ui/dialog/copy-shifts-dialog/utils";

const useShiftDemandData = () => {
	const shiftDemands = useSelector(
		(state: StoreType) => state.shiftDemand.ftShiftDemands
	);

	const filterData = useSelector(
		(state: StoreType) => state.fullTimeShifts?.filterData
	);

	const selectedLocation = useSelector(
		(state: StoreType) => state.fullTimeShifts?.selectedLocation

	);

	const fullTimeShiftDemandStatus = useSelector(
		(state: StoreType) => state.shiftDemand?.getFTShiftDemands?.status
	);

	const postShiftDemandStatus = useSelector(
		(state: StoreType) => state.shiftDemand?.postFTShiftDemands?.status
	);

	const postShiftDemandErrorMessage = useSelector(
		(state: StoreType) => state.shiftDemand?.postFTShiftDemands?.errorMessage
	);

	const FTShiftCurrentDate = useSelector(
		(state: StoreType) => state.fullTimeShifts?.currentDate
	);

	const weekStartDay = useSelector(
		(state: any) => state.user?.userData?.weekStartDay
	);


	const userRolesWithPermission = useSelector(
		(state: any) => state.user.userData.userRolesWithPermissions
	);

	const getFullTimeShiftsMetaStatus = useSelector(
		(state: any) => state.fullTimeShifts.getFullTimeShiftsMeta.status
	);

	return {
		shiftDemands,
		filterData,
		selectedLocation,
		fullTimeShiftDemandStatus,
		FTShiftCurrentDate,
		weekStartDay,
		postShiftDemandStatus,
		postShiftDemandErrorMessage,
		userRolesWithPermission,
		getFullTimeShiftsMetaStatus
	};
};
export default useShiftDemandData;
